<template>
    <v-container fluid class="pa-0">
        <v-row no-gutters>
            <v-col v-if="!isPhoneBool" cols="auto" style="background-color: white; position: relative; width: 250px;">
                <v-list class="py-0" style="position: fixed;  width: 250px;">
                    <h3 class="pa-4 pb-2">Table of contents</h3>
                    <v-list-item-group v-model="scrollItem">
                        <v-list-item v-for="feature in featurelist" :key="feature.id" :value="feature.id" dense>
                            <v-list-item-icon class="mr-2">
                                <v-icon size="16">{{ feature.icon }}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ feature.title }}</v-list-item-title>
                        </v-list-item>
                    </v-list-item-group>
                </v-list>
            </v-col>
            <v-col cols="0">
                <v-progress-linear v-if="loading" indeterminate absolute height="1">
                </v-progress-linear>
                <v-container fluid class="pa-0 py-2">
                    <div v-for="feature in featurelist" :key="'card' + feature.id" :id="feature.id">
                        <FeatureCard :icon="feature.icon" :title="feature.title" :subtitle="feature.subtitle"
                            :description="feature.description" :disabled="feature.disabled"
                            :outlined="scrollItem == feature.id" :active="feature.active"
                            :active-toggle="feature.activeToggle">
                            <template v-if="feature.id == 'QRCODE'" v-slot:more>
                                <v-checkbox :value="PublicPortalJobsEnabled"
                                    label="Show work history in inspection mode."
                                    :disabled="!PublicPortalEnabled || !licencedForCustomerPortal" class="ma-0 mt-2"
                                    dense hide-details @change="togglePublicModeJobsEnabledBool()">
                                </v-checkbox>
                                <!-- 
                                <v-checkbox :value="PublicPortalCustomerEnabled"
                                    label="Show customer information in inspection mode."
                                    :disabled="!PublicPortalEnabled || !licencedForCustomerPortal" class="ma-0" dense
                                    hide-details @change="togglePublicModeCustomerEnabledBool()">
                                </v-checkbox>
                                -->
                            </template>
                        </FeatureCard>
                    </div>
                </v-container>
            </v-col>
        </v-row>
    </v-container>
</template>


<script>
import clientAPI from '@/api/ClientAPIMixin.js';
import LicenseKeys from '@/helpers/Constants/LicenseKeys.js';
import FeatureCard from '@/views/admin/features/FeatureCard.vue';

export default {
    name: 'FeatureList',
    props: {},
    components: {
        FeatureCard,
    },
    mixins: [clientAPI],

    data() {
        return {
            loading: false,
            scrollItem: null,
            groupSettings: null,
        };
    },

    mounted() {
        this.getState();
    },

    methods: {
        async getState() {
            this.loading = true;
            this.groupSettings = await clientAPI.methods.getSettingsGroup({ groups: ["Feature"] });
            this.loading = false;
        },

        scrollToItem(name) {
            var element = document.getElementById(name);

            if (element) {
                element.scrollIntoView();
            }
        },

        async togglePublicModeEnabledBool() {
            this.PublicPortalEnabled = !this.PublicPortalEnabled;
            this.$store.state.GlobalSettings.Features.PublicPortalEnabled = this.PublicPortalEnabled;
        },
        async togglePublicModeJobsEnabledBool() {
            this.PublicPortalJobsEnabled = !this.PublicPortalJobsEnabled;
        },
        async togglePublicModeCustomerEnabledBool() {
            this.PublicPortalCustomerEnabled = !this.PublicPortalCustomerEnabled;
        },
        async toggleLeadsEnabledBool() {
            this.LeadsEnabled = !this.LeadsEnabled;
            this.$store.state.GlobalSettings.Features.LeadsEnabled = this.LeadsEnabled;
        },
        async toggleAssetTypesEnabledBool() {
            this.AssetTypesEnabled = !this.AssetTypesEnabled;
            this.$store.state.GlobalSettings.Features.AssetTypesEnabled = this.AssetTypesEnabled;
        },
        async toggleProjectsEnabledBool() {
            this.ProjectsEnabled = !this.ProjectsEnabled;
            this.$store.state.GlobalSettings.Features.ProjectsEnabled = this.ProjectsEnabled;
        },
        async toggleUnitEnabledBool() {
            this.UnitEnabled = !this.UnitEnabled;
            this.$store.state.GlobalSettings.Features.UnitEnabled = this.UnitEnabled;
        },
        getFeatureSettingValue(name) {
            if (this.features) {
                const setting = this.features.find(e => e.Name.toLowerCase() === name.toLowerCase());
                if (setting) {
                    return setting.SettingValue.toLowerCase() === 'true';
                }
            }
            return false;
        },
        toggleFeatureSettingValue(name) {
            if (this.features) {
                const setting = this.features.find(e => e.Name.toLowerCase() === name.toLowerCase());
                if (setting) {
                    const val = !(setting.SettingValue.toLowerCase() === 'true');
                    setting.SettingValue = val ? 'true' : 'false';
                    clientAPI.methods.setSettingsGroup(this.groupSettings).then(response => {
                        this.groupSettings = response;
                    });
                }
            }
            return false;
        }
    },

    computed: {
        licencedForCustomerPortal() {
            return this.checkIfLicencedByKey(LicenseKeys.CustomerPortal);
        },
        features: {
            get() {
                return this.groupSettings ? this.groupSettings.find(e => e.Group.toLowerCase() === 'feature').Settings : null;
            }
        },
        PublicPortalEnabled: {
            get() {
                return this.getFeatureSettingValue('public.enabled');
            },
            set() {
                this.toggleFeatureSettingValue('public.enabled')
            }
        },
        PublicPortalJobsEnabled: {
            get() {
                return this.getFeatureSettingValue('public.jobs.enabled');
            },
            set() {
                this.toggleFeatureSettingValue('public.jobs.enabled')
            }
        },
        PublicPortalCustomerEnabled: {
            get() {
                return this.getFeatureSettingValue('public.customer.enabled');
            },
            set() {
                this.toggleFeatureSettingValue('public.customer.enabled')
            }
        },
        LeadsEnabled: {
            get() {
                return this.getFeatureSettingValue('LeadsEnabled');
            },
            set() {
                this.toggleFeatureSettingValue('LeadsEnabled')
            }
        },
        AssetTypesEnabled: {
            get() {
                return this.getFeatureSettingValue('AssetTypesEnabled');
            },
            set() {
                this.toggleFeatureSettingValue('AssetTypesEnabled')
            }
        },
        ProjectsEnabled: {
            get() {
                return this.getFeatureSettingValue('ProjectsEnabled');
            },
            set() {
                this.toggleFeatureSettingValue('ProjectsEnabled')
            }
        },
        UnitEnabled: {
            get() {
                return this.getFeatureSettingValue('UnitEnabled');
            },
            set() {
                this.toggleFeatureSettingValue('UnitEnabled')
            }
        },
        featurelist() {
            return [
                {
                    id: 'QRCODE',
                    icon: 'mdi-qrcode-scan',
                    title: 'Inspection mode',
                    subtitle: '(extension of the customer portal)',
                    description: 'Inspection mode is a feature that allows partial equipment information to be accessible in the customer portal without having to log in. <br>The inspection mode page is accessible through a public link or scannable QR code. <br>Having the feature disabled will direct users to the customer portal where they will be required to log in to access the information.',
                    disabled: !this.licencedForCustomerPortal,
                    active: this.PublicPortalEnabled,
                    activeToggle: this.togglePublicModeEnabledBool,
                },
                {
                    id: 'LEADS',
                    icon: '$lead',
                    title: 'Leads',
                    description: 'The leads feature is a tool that allows you to track and manage potential sales leads. <br>The feature adds a button and interface in the technician app that allows technicians to view and create leads for the machines they are working on. <br>In the web there are dedicated pages for managing the list of leads and managing the available lead types.',
                    active: this.LeadsEnabled,
                    activeToggle: this.toggleLeadsEnabledBool,
                },
                {
                    id: 'ASSET_TYPES',
                    icon: '$asset_type',
                    title: 'Asset types',
                    description: 'The asset types feature adds a dropdown to each machine that allows you to categorize what economic asset type they belong to. <br>The feature adds the dropdown itself to the webpage and app, and also a separate webpage where you can manage the available asset types.',
                    active: this.AssetTypesEnabled,
                    activeToggle: this.toggleAssetTypesEnabledBool,
                },
                {
                    id: 'PROJECTS',
                    icon: 'mdi-folder-pound',
                    title: 'Projects',
                    description: 'The projects feature allows you to group orders based on what project they belong to. <br>The feature adds the dropdown to the invoice page on jobs, and also a separate admin page where you can manage the available projects.',
                    active: this.ProjectsEnabled,
                    activeToggle: this.toggleProjectsEnabledBool,
                },
                {
                    id: 'UNIT',
                    icon: '$unit',
                    title: 'Facilities',
                    description: 'The facilities feature allows you to group machines together into a facility. <br>This allows you to quickly add the same group of machines to a new job next time.',
                    active: this.UnitEnabled,
                    activeToggle: this.toggleUnitEnabledBool,
                },
                /*
                {
                    id: 'DATA_IMPORT_EXPORT',
                    icon: 'mdi-database-sync',
                    title: 'Data import and export',
                    description: 'Inspection mode is a feature that allows partial equipment information to be accessible in the customer portal without having to log in. The inspection mode page is accessible through a public link or scannable QR code. Having the feature disabled will direct users to the customer portal where they will be required to log in to access the information.'
                },
                
                {
                    id: 'ODATA_REPORTING',
                    icon: 'mdi-microsoft-excel',
                    title: 'Odata reporting',
                    description: 'Inspection mode is a feature that allows partial equipment information to be accessible in the customer portal without having to log in. <br>The inspection mode page is accessible through a public link or scannable QR code. Having the feature disabled will direct users to the customer portal where they will be required to log in to access the information.'
                },
                */
                {
                    id: 'INTEGRATION_API',
                    icon: 'mdi-code-json',
                    title: 'Integration API',
                    description: "The integration API is a feature that allows you to integrate external systems to ServiceSystem. <br>This entails a API key credential and swagger documentation of the endpoint you can use. <br>For more information, please contact support@qwips.no."
                },

            ];
        },
    },

    watch: {
        scrollItem: function (val) {
            this.scrollToItem(val)
        }
    },
};
</script>


<style lang='scss' scoped></style>